export const initialFieldValues = {
  firstname: '',
  lastname: '',
  email: '',
  password: '',
  marketing: false,
  locale: 'en',
  country: '',
};
